import { ListItemText as NovaBaseListItemText } from '@fme-nova/components'
import { default as MuiBaseListItemText, ListItemTextProps } from '@mui/material/ListItemText'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiListItemText: MsdkStyledComponent<ListItemTextProps | any> = styled(MuiBaseListItemText)`
  color: ${COLORS.text.primary};
`

const NovaListItemText: MsdkStyledComponent<ListItemTextProps | any> = styled(NovaBaseListItemText)`
  color: ${COLORS.text.primary};
`

export const ListItemText = createComponentWrapperWithRef<ListItemTextProps | any>(
  {
    mui: MuiListItemText,
    nova: NovaListItemText,
  },
  'ListItemText',
)
